<template>
  <span :class="['brand-mark', size === 'sm' ? 'brand-mark--sm' : 'brand-mark--md']">
    <img
      :src="iconSrc"
      class="brand-mark__icon"
      alt=""
      aria-hidden="true"
    />
    <img
      :src="wordmarkSrc"
      class="brand-mark__word"
      alt="Happily"
    />
  </span>
</template>

<script>
/**
 * BrandMark — the real Happily lockup (smile-face icon + happily.ai wordmark).
 *
 * Matches `header.vue`'s top-left mark exactly so when the user finishes the
 * signup wizard and lands on the dashboard, the logo in the same spot does
 * not change. The previous version was a CSS-drawn purple disc + Lato
 * "happily" text — visually close but not the brand.
 *
 * Props:
 *  - size: 'sm' | 'md' (default 'md')
 *      'md' — 24px tall (signup default; smaller than the authed header's
 *             32px because the signup shell is more spacious and the mark
 *             should sit quietly above the editorial content)
 *      'sm' — 20px tall (compact contexts)
 */
const iconAsset = require('@/assets/images/wv-monthly-insights/Icon.png')
const wordmarkAsset = require('@/assets/images/navbar/happily.ai.png')

export default {
  name: 'BrandMark',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: (v) => v === 'sm' || v === 'md',
    },
  },
  computed: {
    iconSrc() { return iconAsset },
    wordmarkSrc() { return wordmarkAsset },
  },
}
</script>

<style lang="scss" scoped>
@import './_shared.scss';

.brand-mark {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1;
  user-select: none;
}

.brand-mark__icon,
.brand-mark__word {
  display: block;
  flex-shrink: 0;
  height: 24px;
  width: auto;
}

.brand-mark--sm {
  gap: 6px;
}
.brand-mark--sm .brand-mark__icon,
.brand-mark--sm .brand-mark__word {
  height: 20px;
}
</style>
